export enum Genre {
  action = 'Action',
  arcade = 'Arcade',
  simulation = 'Simulation',
  casual = 'Casual',
  puzzles = 'Puzzle',
  racing = 'Racing',
  strategy = 'Strategy',
}

export enum OS {
  ios = 'ios',
  android = 'android',
  unknown = 'unknown',
}

export enum Route {
  home = 'home',
  game = 'game',
  genres = 'genres',
}

export enum HomePageSection {
  moreGamesLikeThis = 'moreGamesLikeThis',
  gameOfDay = 'gameOfDay',
  genre1 = 'genre1',
  genre2 = 'genre2',
  genre3 = 'genre3',
  genre4 = 'genre4',
  genre5 = 'genre5',
  genre6 = 'genre6',
  genre7 = 'genre7',
}

export enum ABTest {
  default = '7.0',
  moreGamesFirst = '1.1', // Outdated
  withScrollInitializer = '1.2', // Outdated
  deferredCloseIcon = '2.1', // Outdated
  fastDeferredCloseIcon = '2.2', // Outdated
  changeCloseIconAndLogo = '2.3', // Outdated
  pokiLikeHome = '3.1', // Outdated
  directInstallation = '5.1', // Outdated
  useLocalization = '5.2', // Outdated
  switchMainVideo = '7.1',
  showGetBtnOnGame = '7.2',
  autoShowGetBtnOnGame = '7.3',
}

export type TQueryParamKey = 'idfa' | 'idfv' | 'appkey' | 'lang' | 'os' | 'country' | 'saykit_version' | 'app_version'
  | 'install_date';

export type TQueryParams = {
  [key in TQueryParamKey]?: string | null;
};

export type TReview = {
  id: number;
  rating: number;
  date: string;
  user: string;
  userLogo?: string;
  content: string;
};

export type Feature = {
  logoURL: string;
  title: string;
  subtitle?: string;
};

export type TGame = {
  id: string;
  name: string;
  title?: string;
  description: string;
  reviews?: TReview[];
  reviewsCount: number;
  rating: number;
  ratingStars?: number[];
  genre: Genre;
  logoURL: string;
  screenshots: string[];
  tags: string[];
  features: Feature[];
  trackURL: TTrackUrl;
  video?: string;
  videoShort?: string;
  videoPoster?: string;
  gamesLikeThis: string[];
  isLookALike?: boolean;
  isGameOfDay?: boolean;
};

export type TTrackUrl = {
  click: string;
  impression: string;
}

export type TBackendFeature = {
  icon_url: string;
  subtitle: string;
  title: string;
};

export type TBackendGame = {
  Name: string;
  app_key: string;
  description: string;
  features: TBackendFeature[] | null;
  games_like_this: string[];
  genres: Genre[];
  icon_url: string;
  is_game_of_the_day: boolean;
  is_lookalike: boolean;
  rating: number;
  reviews_count: number;
  screenshots: string[];
  store_id: string;
  tags: string[] | null;
  title: string;
  track_urls: TTrackUrl;
  video_poster_url: string;
  video_url: string;
  video_url_short: string;
};

export type TBackendGames = {
  request_id: string;
  items: TBackendGame[];
  games_like: string[];
  ab_test_id?: string;
};

export type TBackendResponse = TBackendGames & {
  code?: string;
  message?: string;
};
